import { render, staticRenderFns } from "./sale-order-mark-promote.vue?vue&type=template&id=39a8456e&scoped=true&"
import script from "./sale-order-mark-promote.vue?vue&type=script&lang=js&"
export * from "./sale-order-mark-promote.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-mark-promote.vue?vue&type=style&index=0&id=39a8456e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a8456e",
  null
  
)

export default component.exports